// (2026-06-08) Helpers compartidos del módulo de Compras (frontend).
import { toast } from "react-toastify";

// (2026-06-09) Validadores de formato del sistema (los MISMOS que usan los
// maestros de Ventas: Clientes/Proformas/Facturas). Se re-exportan para que
// los formularios de Compras apliquen idénticas reglas de RIF/teléfono/correo.
export {
  validateFormatRif,
  validateFormatPhone,
  validateFormatEmail,
} from "../../utils/formatters";

// Monedas fijas del sistema (seed: 1=USD, 2=EUR, 3=VES).
export const MONEDAS = [
  { id: 3, codigo: "VES" },
  { id: 1, codigo: "USD" },
  { id: 2, codigo: "EUR" },
];

export const fmt = (val) => {
  const n = Number(val);
  if (Number.isNaN(n)) return val == null ? "" : String(val);
  return n.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const monedaCodigo = (id) => (MONEDAS.find((m) => m.id === Number(id)) || {}).codigo || "";

export const handleApiError = (e, fallback = "Ocurrió un error.") => {
  const d = e?.response?.data || {};
  toast.error(d.mensaje || d.error || e?.message || fallback);
};

export const hoyISO = () => new Date().toISOString().slice(0, 10);

export const upper = (v) => (typeof v === "string" ? v.toUpperCase() : v);

// (2026-06-09) Máscara de RIF — portada 1:1 desde components/Clients/FormClients.js
// para garantizar comportamiento idéntico (V-12345678-9 o cédula de 6-8 dígitos).
// `prev` es el valor anterior, usado como fallback si la entrada no matchea el
// patrón tradicional (mismo criterio que el maestro de Clientes).
//
// (2026-08-03, ronda 2 / T1) Clase de letras `[VJEPGC]` — la 'C' (Comunal) entró
// por decisión del usuario y `utils.validar_rif` la admite (`^[VEJGPC]-\d{8}-\d$`,
// utils.py:351). SIN esta letra la máscara BORRABA la C mientras se teclea: el
// usuario no podía siquiera escribir el RIF de un proveedor comunal. Portado
// EXACTAMENTE del maestro FormClients.js — si allí cambia la clase, cambia aquí.
export const maskRif = (raw, prev = "") => {
  let value = String(raw ?? "").toUpperCase().replace(/[^A-Z0-9-]/g, "");
  if (value.length === 1) {
    if (!/[VJEPGC123456789]/.test(value)) value = "";
  } else if (value.length === 2) {
    if (/[VJEPGC]/.test(value[0]) && /[1234567890]/.test(value[1]) && !value.includes("-")) {
      if (/[VJEPGC1234567890-]/.test(value[1])) {
        value = value[0] + "-" + value[1];
      } else {
        value = value[0];
      }
    } else if (!/[1234567890]/.test(value)) {
      value = value[0];
    }
  } else if (value.length > 2) {
    const matchSoloNumeros = value.match(/^\d{0,8}$/);
    if (matchSoloNumeros) {
      value = matchSoloNumeros[0];
    } else {
      const match = value.match(/^([VJEPGC])-(\d{0,8})-?(\d{0,1})?$/);
      if (match) {
        const [, letra, numeros, verificador] = match;
        value = `${letra}-${numeros}${numeros.length === 8 ? "-" : ""}${verificador || ""}`;
      } else {
        value = prev;
      }
    }
  }
  return value;
};

// (2026-06-09) Máscara de teléfono — portada 1:1 desde FormClients.js
// (0000-0000000). Deja solo dígitos e inserta el guion tras los primeros 4.
export const maskPhone = (raw) => {
  let v = String(raw ?? "").replace(/\D/g, "").slice(0, 11);
  if (v.length > 4) v = v.slice(0, 4) + "-" + v.slice(4);
  return v;
};
